/**
 * 查询观看限制
 * Create by liaokai on 2020-06-11 17:55:39
 */
import {toPost} from "../../http-utils";

export const liveLook = toPost<
    {
        live_id : string
    },
    {
        "type": number, //1 免费 2 支付 3 邀请码 4 密码
        "money": number, //需要支付金额
        "password": string, //需要填写的密码
        "invitation_code_count": string //现在一共生成的邀请码个数
        "group_id": number //组id
    }
>("/merchant/live/liveLook");
